<template>
  <div class="right-drawer" :style="{
    width: value ? width : '0',
    
  }">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "NavigationDrawer",
  props: ["value", "width"],
  data() {
    return {
    };
  },
};
</script>

<style>
.right-drawer {
  position: fixed;
  top: 0;
  right: 0;
  width: 0; /* initially */
  overflow: hidden;
  height: 100vh;
  padding-left: 0; /* initially */
  border-left: 1px solid whitesmoke;
  background: white;
  z-index: 200;
  transition: all 0.2s; /* for the animation */
}
</style>
